import { useEffect, useRef } from "react";
import { Application, Assets, Sprite } from "pixi.js";

import zombieKid from "../../assets/imdv_logo_zombie_kid.png";
import text from "../../assets/imdv_logo_text.png";

import "./logoIMDV.css";

export default function LogoIMDV({
    size = 200,
    zombieTint = 0xa69f72,
    textTint = 0xbfad8c,
    alpha = 0.95,
    className = ""
}) {
    const pixiRef = useRef(null);

    useEffect(() => {
        let app;

        async function initPixi() {
            const SOURCE_WIDTH = 3261;
            const SOURCE_HEIGHT = 1000;

            const DISPLAY_HEIGHT = size;
            const DISPLAY_WIDTH = SOURCE_WIDTH * (DISPLAY_HEIGHT / SOURCE_HEIGHT);
            const LOGO_SCALE = DISPLAY_HEIGHT / SOURCE_HEIGHT;

            app = new Application();

            await app.init({
                width: DISPLAY_WIDTH,
                height: DISPLAY_HEIGHT,
                backgroundAlpha: 0,
                antialias: true,
                resolution: 2,
                autoDensity: false
            });

            if (!pixiRef.current) return;

            pixiRef.current.appendChild(app.canvas);

            const [zombieTexture, textTexture] = await Promise.all([
                Assets.load(zombieKid),
                Assets.load(text)
            ]);

            const zombieSprite = new Sprite(zombieTexture);
            const textSprite = new Sprite(textTexture);

            zombieSprite.anchor.set(0.5);
            textSprite.anchor.set(0.5);

            zombieSprite.scale.set(LOGO_SCALE);
            textSprite.scale.set(LOGO_SCALE);

            zombieSprite.x = DISPLAY_WIDTH / 2;
            zombieSprite.y = DISPLAY_HEIGHT / 2;

            textSprite.x = DISPLAY_WIDTH / 2;
            textSprite.y = DISPLAY_HEIGHT / 2;

            zombieSprite.tint = zombieTint;
            textSprite.tint = textTint;

            zombieSprite.alpha = alpha;
            textSprite.alpha = alpha;

            app.stage.addChild(zombieSprite);
            app.stage.addChild(textSprite);
        }

        initPixi();

        return () => {
            if (app) {
                app.destroy(true);
            }
        };
    }, [size, zombieTint, textTint, alpha]);

    return (
        <div
            className={`logo-imdv ${className}`}
            ref={pixiRef}
        />
    );
}